module.exports = __webpack_public_path__ + "static/img/collectionpages.0354e592.png";